module.exports = __webpack_public_path__ + "img/arrow-down-white.dcb62b80.svg";